import { Box, getVariant, Progress, ThemeUIStyleObject } from '@apia/theme';
import { getLabel } from '@apia/util';
import React, { MouseEvent, useRef, useState } from 'react';
import { IconButton } from '../forms';

export const Dropzone = ({
  sx,
  className,
  messageError,
  progress = 0,
  defaultLabel = getLabel('btnUploadClass').text,
  draggingLabel = getLabel('lblDroping').text,
  onClick,
  onChange,
  handleInfoButton,
  infoButtonProps,
}: {
  sx?: ThemeUIStyleObject;
  className?: string;
  messageError?: string;
  progress?: number;
  defaultLabel?: string;
  draggingLabel?: string;
  infoButtonProps?: any;
  onClick?: (e: MouseEvent) => void;
  onChange?: (e: File[]) => any;
  handleInfoButton?: (e: MouseEvent) => void;
}) => {
  const innerSx = messageError
    ? { borderLeft: '2px solid', borderColor: 'danger' }
    : {};

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClick = (ev: MouseEvent) => {
    onClick?.(ev);

    if (!ev.defaultPrevented) {
      fileInputRef.current?.click();
    }
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const [isDragging, setIsDragging] = useState(false);
  const handleDragStart = (_e: React.DragEvent<HTMLDivElement>) => {
    setIsDragging(true);
  };
  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
  };

  return (
    <Box
      {...getVariant('layout.execution.components.uploader.dropzone')}
      className="dropzone__container"
    >
      <Box
        tabIndex={0}
        sx={{ ...innerSx, sx }}
        className={`dropzone ${className ?? ''}`}
        onClick={handleClick}
        onKeyDown={(ev) => {
          if (ev.code === 'Enter' || ev.code === 'Space') {
            handleClick(ev as any);
          }
        }}
        onDrop={(e) => {
          e.preventDefault();

          const newFiles = Array.from(e.dataTransfer.files);
          setIsDragging(false);
          onChange?.(newFiles);
        }}
        onDragEnter={handleDragStart}
        onDragLeave={handleDragLeave}
        onDragOver={handleDragOver}
      >
        {progress > 0 && progress < 100 && (
          <Progress max={100} value={progress} className="progressBar" />
        )}
        {messageError ? (
          <Box color="danger">{messageError}</Box>
        ) : isDragging ? (
          draggingLabel
        ) : (
          defaultLabel
        )}

        <input
          multiple
          type="file"
          aria-label={defaultLabel}
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={(e) => {
            e.preventDefault();

            if (e.target.files) {
              const newFiles = Array.from([...e.target.files]);
              onChange?.(newFiles);
              e.target.value = '';
            }
          }}
        />
      </Box>
      {handleInfoButton && (
        <IconButton
          {...infoButtonProps}
          aria-label={
            infoButtonProps?.['aria-label'] || getLabel('btnInfo').text
          }
          className="info"
          iconSize={'Sm'}
          icon="Info"
          onMouseEnter={handleInfoButton}
          onClick={handleClick}
        />
      )}
    </Box>
  );
};
